import axios from 'src/utils/axios';
const local_key = 'fotograflar'




// Fişe ait fotoğrafı local storage'a yazar.
export const saveFotograf = (fisNo, dataUri, DosyaTipi, DosyaTipiText, FileType) => {
  try {
    let photos_txt = localStorage.getItem(local_key);
    if (photos_txt == null) {
      localStorage.setItem(local_key, "[]");
      photos_txt = "[]";
    }
    let photos = JSON.parse(photos_txt);
    const id_array = photos.map(p => p.DOSYA_ID);
    let id = -1;
    while (true) {
      if (id_array.indexOf(id) === -1) {
        break;
      }
      id -= 1;
    }
    photos.push({
      DOSYA_ADI: DosyaTipiText,
      DOSYA_DATA: dataUri,
      DOSYA_FIS_NO: fisNo,
      DOSYA_ID: id,
      DOSYA_TIPI: FileType,
      TARIH: "21.05.2020 18:39",
      TIP: DosyaTipiText,
      DOSYA_TIPI_INT: DosyaTipi,
    });

    localStorage.removeItem(local_key);
    localStorage.setItem(local_key, JSON.stringify(photos));
    return true;
  } catch (error) {
    return false;
  }
};

export const deleteFotografWithId = (id) => {
  const photos = loadTumFotograflar();
  const afterDelete = photos.filter(p => parseInt(p.DOSYA_ID) !== parseInt(id));
  localStorage.setItem(local_key, JSON.stringify(afterDelete));
}

// Fişe ait tüm fotoğrafları döner.
export const loadFotograf = (fisNo) => {
  try {
    const photos_txt = localStorage.getItem(local_key);
    const photos = JSON.parse(photos_txt);
    return photos.filter(f => parseInt(f.DOSYA_FIS_NO) === parseInt(fisNo));
  } catch (error) {
    return [];
  }
};

// Tüm fotoğrafları döner.
const loadTumFotograflar = () => {
  try {
    const photos_txt = localStorage.getItem(local_key);
    return JSON.parse(photos_txt);
  } catch (error) {
    return [];
  }
};


export const uploadFotograf = async fisNo => {
  try {
    let photos = loadFotograf(fisNo);
    if (photos.length === 0) {
      return 0;
    }
    for (let i = 0; i < photos.length; i++) {
      await UploadFotografHelper(photos[i]);
    }
    return photos.length;
  } catch (error) {
    return -1;
  }
}


const UploadFotografHelper = async fotograf => {
  try {
    await urltoFile(fotograf.DOSYA_DATA, fotograf.DOSYA_ADI, fotograf.DOSYA_TIPI)
      .then(async function (filelar) {
        const file = filelar;
        let FileType = file.type;
        let base64Result = "";
        base64Result = img.data
        const data = {
          Title: fotograf.DOSYA_ADI,
          MIMEType: FileType,
          ServiscePaperId: fotograf.DOSYA_FIS_NO,
          DosyaTipi: fotograf.DOSYA_TIPI_INT,
          FileData: base64Result
        }

        const config = {
          headers: { 'Content-Type': 'application/json' }
        }

        const res = await axios.post('/FileImportExport/ArtemisFileUpload', data, config)
          .then(response => {
            deleteFotografWithId(fotograf.DOSYA_ID);
          }).catch(error => {
            // deleteFotografWithId(fotograf.DOSYA_ID);
          });
        return res;
      });
  } catch (error) {
  }
}

async function urltoFile(url, filename, mimeType) {
  return (fetch(url)
    .then(async function (res) { return res.arrayBuffer(); })
    .then(async function (buf) { return new File([buf], filename, { type: mimeType }); })
  );
}


export async function base64Reader(file) {
  let result_base64 = await new Promise((resolve) => {
    let fileReader = new FileReader();
    fileReader.onload = (e) => resolve(fileReader.result);
    fileReader.readAsDataURL(file);
  });
  return result_base64.split(',')[1] || '';
}
